export interface IUser {
    id: number,
    email: string,
    name: string
}

export class User implements IUser {
    constructor (public id: number, public name: string, public email:string) {}
}
